import { render, staticRenderFns } from "./MasterRplInstrukturEdit.vue?vue&type=template&id=4d754924&"
import script from "./MasterRplInstrukturEdit.vue?vue&type=script&lang=js&"
export * from "./MasterRplInstrukturEdit.vue?vue&type=script&lang=js&"
import style0 from "./MasterRplInstrukturEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports